export const hoursEntryActivity = {
  COMMUNICATION: 'communication',
  PLANNING: 'planning',
  IMPLEMENTATION: 'implementation',
  REVIEWING: 'reviewing',
  OTHER: 'other',
};

export const activityOptions = [
  {
    value: hoursEntryActivity.COMMUNICATION,
    label: hoursEntryActivity.COMMUNICATION,
  },
  {
    value: hoursEntryActivity.PLANNING,
    label: hoursEntryActivity.PLANNING,
  },
  {
    value: hoursEntryActivity.IMPLEMENTATION,
    label: hoursEntryActivity.IMPLEMENTATION,
  },
  {
    value: hoursEntryActivity.REVIEWING,
    label: hoursEntryActivity.REVIEWING,
  },
  {
    value: hoursEntryActivity.OTHER,
    label: hoursEntryActivity.OTHER,
  },
];
